import React from 'react';
import { View } from 'react-native';

import { get as _get } from 'lodash';
import PropTypes from 'prop-types';

import { useTheme, Types } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { MyPlanExtrasModal } from '@vfgroup-oneplatform/framework/MyPlan';

import styles from './PlanExtrasModal.Styles';

function PlanExtrasModal({
  toggleModal,
  isVisible,
  closeModal,
  isLoading,
  isPlansExtrasLoading,
  plansExtrasError,
  plansExtrasErrorScreenProps,
  saveCardIsLoading,
  extraModalJson,
  handleConfirmButtonPress,
  isLoadingSuccessful,
  doneLoadingSubtitlePlaceholders,
  isResetData,
  paymentOptions,
  loadingFailureError,
  ...props
}) {
  const theme = useTheme();

  const renderCustomPaymentMethod = () => <View style={styles.divider(theme)} />;

  const paymentTypeProps = {
    paymentTypeTitle: _get(extraModalJson, 'paymentTypeTitle', ''),
    paymentTypeTitleStyle: {},
    paymentTypeOptions: _get(extraModalJson, 'options', []),
    paymentTypeSectionContainerStyle: styles.paymentTypeSectionContainerStyle,
  };
  const paymentAmountProps = {
    paymentAmountTitle: _get(extraModalJson, 'paymentAmountTitle', ''),
    paymentAmountFirstTypeOptions: _get(extraModalJson, 'options[0].items', []),
    paymentAmountSecondTypeOptions: _get(extraModalJson, 'options[1].items', []),
    paymentAmountContainerStyle: styles.paymentAmountContainerStyle,
  };
  const paymentFooterDescriptionProps = {
    paymentFooterFirstTypeDescription: _get(extraModalJson, 'options[0].description', ''),
    paymentFooterSecondTypeDescription: _get(extraModalJson, 'options[1].description', ''),
    footerDescriptionStyle: styles.footerDescriptionStyle,
  };
  const confirmButtonProps = {
    confirmButtonType: Types.PRIMARY,
    confirmButtonTitle: _get(extraModalJson, 'paymentMethod.firstButtonText', ''),
    handleConfirmButtonPress: handleConfirmButtonPress,
  };
  const cancelButtonProps = {
    cancelButtonType: Types.SECONDARY,
    cancelButtonTitle: _get(extraModalJson, 'paymentMethod.secondButtonText', ''),
    handleCancelButtonPress: closeModal,
  };
  const loadingProps = {
    loadingMessage: _get(extraModalJson, 'loadingScreen.loadingMessage', ''),
    loadingMessageTextStyle: styles.loadingMessageTextStyle,
    loadingLottieViewStyle: styles.loadingLottieViewStyle,
    isLoading,
  };
  const doneLoadingProps = {
    isLoadingSuccessful: isLoadingSuccessful,
    doneLoadingMainTitle: isLoadingSuccessful
      ? _get(extraModalJson, 'resultScreen.title', '')
      : _get(loadingFailureError, 'message', ''),
    doneLoadingMainTitleStyle: styles.doneLoadingMainTitleStyle(theme),
    doneLoadingSubTitle: isLoadingSuccessful
      ? _get(extraModalJson, 'resultScreen.message', '')
      : _get(loadingFailureError, 'description', ''),
    doneLoadingSubtitlePlaceholders: doneLoadingSubtitlePlaceholders,
    doneLoadingSubTitleStyle: styles.doneLoadingSubTitleStyle(theme),
    doneLoadingPrimaryButtonType: Types.PRIMARY,
    doneLoadingPrimaryButtonText: isLoadingSuccessful
      ? _get(extraModalJson, 'resultScreen.buttonText', '')
      : _get(extraModalJson, 'resultScreen.failureButtonText', ''),
    doneLoadingPrimaryButtonAction: isLoadingSuccessful ? closeModal : null,
    withDoneLoadingSecondaryButton: !isLoadingSuccessful,
    doneLoadingSecondaryButtonType: Types.SECONDARY,
    doneLoadingSecondaryButtonText: _get(
      extraModalJson,
      'resultScreen.failureSecondaryButtonText',
      '',
    ),
    onTryAgainPress: handleConfirmButtonPress,
  };

  const extrasProps = {
    isPlansExtrasLoading,
    plansExtrasError,
    plansExtrasErrorScreenProps,
  };

  return (
    <MyPlanExtrasModal
      toggleModal={toggleModal}
      isVisible={isVisible}
      closeModal={closeModal}
      onGoBackPress={closeModal}
      type={Types.SECONDARY}
      saveCardIsLoading={saveCardIsLoading}
      title={_get(extraModalJson, 'title', '')}
      headerStyle={styles.extrasModalHeaderStyle}
      {...paymentTypeProps}
      {...paymentAmountProps}
      {...paymentFooterDescriptionProps}
      {...confirmButtonProps}
      {...cancelButtonProps}
      {...loadingProps}
      {...doneLoadingProps}
      {...extrasProps}
      btnsContainerStyle={styles.btnsContainerStyle}
      isResetData={isResetData}
      paymentOptions={paymentOptions}
      renderCustomPaymentMethod={renderCustomPaymentMethod}
      isPaymentMethod={false}
    />
  );
}

PlanExtrasModal.propTypes = {
  toggleModal: PropTypes.func,
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
  isLoading: PropTypes.bool,
  saveCardIsLoading: PropTypes.bool,
  extraModalJson: PropTypes.object,
  handleConfirmButtonPress: PropTypes.func,
  isLoadingSuccessful: PropTypes.bool,
  doneLoadingSubtitlePlaceholders: PropTypes.arrayOf(PropTypes.string),
  isResetData: PropTypes.bool,
  paymentOptions: PropTypes.object,
  loadingFailureError: PropTypes.object,
  isPlansExtrasLoading: PropTypes.bool,
  plansExtrasError: PropTypes.shape({
    message: PropTypes.string,
  }),
  plansExtrasErrorScreenProps: PropTypes.shape({
    title: PropTypes.string,
    onPrimaryBtnPress: PropTypes.func,
    primaryBtnTitle: PropTypes.string,
  }),
};

export default PlanExtrasModal;
